import type { Message } from '@/shared/api';

type MessageReconciliationDependencies = {
  confirmOutgoing: (message: Message) => Promise<void>;
  upsertServer: (message: Message) => void;
};

const reconcileMessageConfirmation = (dependencies: MessageReconciliationDependencies) => {
  const confirmedMessageIds = new Set<Message['id']>();

  return async (message: Message): Promise<void> => {
    if (confirmedMessageIds.has(message.id)) {
      return;
    }

    confirmedMessageIds.add(message.id);
    await dependencies.confirmOutgoing(message);
    dependencies.upsertServer(message);
  };
};

export { reconcileMessageConfirmation };
